import { FormattedMessage } from 'react-intl';

export const FieldTypesOptions = [
  {
    label: (
      <FormattedMessage
        id="ui-plugin-inventory-templates.fieldTypesOptions.chooseMsg"
        defaultMessage="Choose field data type"
      />
    ),
    value: '',
  },
  {
    label: (
      <FormattedMessage
        id="ui-plugin-inventory-templates.fieldTypesOptions.text"
        defaultMessage="Text field"
      />
    ),
    value: 'text',
  },
  {
    label: (
      <FormattedMessage
        id="ui-plugin-inventory-templates.fieldTypesOptions.textArea"
        defaultMessage="Text area field"
      />
    ),
    value: 'textArea',
  },
  {
    label: (
      <FormattedMessage
        id="ui-plugin-inventory-templates.fieldTypesOptions.select"
        defaultMessage="Select field"
      />
    ),
    value: 'select',
  },
  {
    label: (
      <FormattedMessage
        id="ui-plugin-inventory-templates.fieldTypesOptions.checkbox"
        defaultMessage="Checkbox field"
      />
    ),
    value: 'checkbox',
  },
  {
    label: (
      <FormattedMessage
        id="ui-plugin-inventory-templates.fieldTypesOptions.date"
        defaultMessage="Date field"
      />
    ),
    value: 'date',
  },
  {
    label: (
      <FormattedMessage
        id="ui-plugin-inventory-templates.fieldTypesOptions.hijriDate"
        defaultMessage="Hijri date field"
      />
    ),
    value: 'hijriDate',
    disabled: true,
  },
  {
    label: (
      <FormattedMessage
        id="ui-plugin-inventory-templates.fieldTypesOptions.radioButton"
        defaultMessage="Radio button"
      />
    ),
    value: 'radioButton',
    disabled: true,
  },
  {
    label: (
      <FormattedMessage
        id="ui-plugin-inventory-templates.fieldTypesOptions.fieldArray"
        defaultMessage="Array field"
      />
    ),
    value: 'fieldArray',
    disabled: true,
  },
  {
    label: (
      <FormattedMessage
        id="ui-plugin-inventory-templates.fieldTypesOptions.toggleButton"
        defaultMessage="Toggle button"
      />
    ),
    value: 'toggleButton',
    disabled: true,
  },
];

export const SchemaTypes = [
  {
    label: (
      <FormattedMessage
        id="ui-plugin-inventory-templates.schemaTypes.chooseMsg"
        defaultMessage="Choose scheme type"
      />
    ),
    value: '',
  },
  {
    label: (
      <FormattedMessage
        id="ui-plugin-inventory-templates.schemaTypes.default"
        defaultMessage="Default"
      />
    ),
    value: 'default',
  },
  {
    label: (
      <FormattedMessage
        id="ui-plugin-inventory-templates.schemaTypes.customField"
        defaultMessage="Custom field"
      />
    ),
    value: 'customField',
  },
];

export const EntityTypes = [
  {
    label: (
      <FormattedMessage
        id="ui-plugin-inventory-templates.entityTypes.chooseMsg"
        defaultMessage="Choose record type"
      />
    ),
    value: '',
  },
  {
    label: (
      <FormattedMessage
        id="ui-plugin-inventory-templates.entityTypes.instance"
        defaultMessage="Instance"
      />
    ),
    value: 'instance',
  },
  {
    label: (
      <FormattedMessage
        id="ui-plugin-inventory-templates.entityTypes.holding"
        defaultMessage="Holdings"
      />
    ),
    value: 'holding',
  },
  {
    label: (
      <FormattedMessage
        id="ui-plugin-inventory-templates.entityTypes.item"
        defaultMessage="Items"
      />
    ),
    value: 'item',
  },
];

export const FieldsListColumnMapping = {
  label: (
    <FormattedMessage
      id="ui-plugin-inventory-templates.fields.list.columnMapping.column.label"
      defaultMessage="Label"
    />
  ),
  schema: (
    <FormattedMessage
      id="ui-plugin-inventory-templates.fields.list.columnMapping.column.schema"
      defaultMessage="Schema"
    />
  ),
  isRequired: (
    <FormattedMessage
      id="ui-plugin-inventory-templates.fields.list.columnMapping.column.isRequired"
      defaultMessage="Required"
    />
  ),
  canEdit: (
    <FormattedMessage
      id="ui-plugin-inventory-templates.fields.list.columnMapping.column.canEdit"
      defaultMessage="Editable"
    />
  ),
  isRepeatable: (
    <FormattedMessage
      id="ui-plugin-inventory-templates.fields.list.columnMapping.column.isRepeatable"
      defaultMessage="Repeatable"
    />
  ),
  info: (
    <FormattedMessage
      id="ui-plugin-inventory-templates.fields.list.columnMapping.column.info"
      defaultMessage="Info"
    />
  ),
};

// Authority creation routes
export const createAuthorityRoute = '/marc-authorities/quick-marc/create-authority';

// Authority linked fields configuration
export const AUTHORITY_LINKED_FIELDS = [
  'subjects.value',
  'series.value',
  'alternativeTitles.alternativeTitle',
  'contributors.name',
];

// Function to get authority type based on contributor name type
export const getAuthorityTypeByContributorNameType = (
  contributorNameTypeId,
  controlledVocab,
) => {
  if (!contributorNameTypeId || !controlledVocab?.contributorNameTypes) {
    return { searchType: 'all' };
  }

  const nameType = controlledVocab.contributorNameTypes.find(
    (type) => type.id === contributorNameTypeId,
  );

  // Mapping based on name type
  switch (nameType?.name) {
    case 'Personal name':
      return { searchType: 'personalName' };
    case 'Corporate name':
      return { searchType: 'corporateName' };
    case 'Meeting name':
      return { searchType: 'meetingName' };
    default:
      return { searchType: 'all' };
  }
};

// Function to determine authority type for field
export const getAuthorityTypeForField = (
  fieldPath,
  formValues,
  fieldIndex,
  controlledVocab,
) => {
  const navigationSegments = {
    search: 'search',
    browse: 'browse',
  };

  const getInitialValues = (dropdownValue) => ({
    [navigationSegments.search]: {
      dropdownValue,
      searchIndex: dropdownValue,
    },
    [navigationSegments.browse]: {
      dropdownValue,
      searchIndex: dropdownValue,
    },
    segment: navigationSegments.browse,
  });

  switch (fieldPath) {
    case 'subjects.value':
      return {
        searchType: 'subject',
        initialValues: getInitialValues('subject'),
      };
    case 'series.value':
      return {
        searchType: 'uniformTitle',
        initialValues: getInitialValues('uniformTitle'),
      };
    case 'alternativeTitles.alternativeTitle':
      return {
        searchType: 'uniformTitle',
        initialValues: getInitialValues('uniformTitle'),
      };
    case 'contributors.name':
      // Get contributor name type from the same array element
      const contributorNameTypeId =
        formValues?.instanceData?.contributors?.[fieldIndex]?.contributorNameTypeId;
      const contributorConfig = getAuthorityTypeByContributorNameType(
        contributorNameTypeId,
        controlledVocab,
      );
      let dropdownValue = 'keyword';
      if (contributorConfig.searchType === 'personalName') {
        dropdownValue = 'personalNameTitle';
      } else if (contributorConfig.searchType === 'corporateName') {
        dropdownValue = 'corporateNameTitle';
      } else if (contributorConfig.searchType === 'meetingName') {
        dropdownValue = 'corporateNameTitle';
      }
      return {
        ...contributorConfig,
        initialValues: getInitialValues(dropdownValue),
      };
    default:
      return {
        searchType: 'all',
        initialValues: getInitialValues('keyword'),
      };
  }
};
